module.exports = __webpack_public_path__ + "img/V15.77f9799c.png";